<!-- 上拉框式选择框 -->
<template>
  <div>
    <!-- 触发按钮 -->
    <div
      class="popup-btn"
      :class="extralClass"
      @click="openModal"
    >
      <span>
        {{ allOption && !showContent && showContent !== 0 ? '全部' :showContent }}
      </span>
      <vanIcon name="play" size="12"/>
    </div>
    <!-- 上拉框 -->
    <vanActionSheet
      v-model="show"
      :actions="actions"
      @select="onSelect"
      :cancel-text="cancelText"
      :close-on-click-action="closeOnClickAction"
      @cancel="onCancel"
    />
  </div>
</template>

<script>
export default {
  name: 'action-sheet-select',
  props: {
    val: {
      type: String,
      default: ''
    },
    // 是否展示全部字样
    allOption: {
      type: Boolean,
      default: true
    },
    // 是否展示取消
    closeOnClickAction: {
      type: Boolean,
      default: true
    },
    // 取消按钮内容
    cancelText: {
      type: String,
      default: '取消'
    },
    selectList: {
      type: Array,
      default() {
        return []
      }
    },
    // 外部样式
    extralClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 模态框状态
      show: false,
      // 按钮上具体展示的内容
      showContent: '',
      // 最终展示的数组，区分于传入数组
      actions: []
    }
  },
  watch: {
    // 双向绑定val
    val: {
      handler(val) {
        this.showContent = val
      },
      immediate: true
    }
  },
  created() {
    // 添加“全部选项”
    if (this.allOption) {
      // 判断是否已经携带了全部选项
      let isHaveAll = false
      this.selectList.forEach((item) => {
        // 若有为空字符的则判断为全部
        if (!item.value && item.value !== 0) {
          isHaveAll = true
        }
      })
      // 没全部则加一个
      if (!isHaveAll) {
        this.actions = [{name: '全部', value: ''}, ...this.selectList]
      } else {
        // 有则直接合入
        this.actions = [...this.selectList]
      }
    } else {
      this.actions = [...this.selectList]
    }
  },
  methods: {
    // 打开modal
    openModal() {
      this.show = true
    },
    // 触发选择
    onSelect(item) {
      // 关闭
      this.show = false
      // 更换选项按钮内容
      this.showContent = item.name
      // 自定义双向绑定
      this.$emit('input', item.value)
      // 抛出事件
      this.$emit('selectItem', item)
    },
    // 取消事件
    onCancel() {
      this.show = false
      this.$emit('onCancel')
    }
  }
}
</script>

<style lang="less" scoped>
  .popup-btn {
      width:130px;
      height:40px;
      background: #737992;
      border-radius:20px;
      box-sizing: border-box;
      padding: 0 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      font-size: 14px;
      /deep/.van-icon-play {
        transform: rotate(90deg);
      }
    }
</style>
